import { useTranslation } from 'react-i18next';

const InstallationsPanel = ({ appointment }) => {
  const { t } = useTranslation();

  if (appointment.installations && appointment.installations.length > 0) {
    return (
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-gray-700">
            Veicoli da installare ({appointment.installations.length})
          </p>
          {appointment.total_duration && (
            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
              Durata totale: {Math.floor(appointment.total_duration / 60)}h {appointment.total_duration % 60}min
            </span>
          )}
        </div>
        {appointment.installations.map((inst, index) => {
          const sfStatus = (inst.salesforce_status || '').toLowerCase();
          const sfComplete = sfStatus === 'complete' || sfStatus === 'completed';
          const workStatus = (inst.status || '').toLowerCase();
          return (
          <div key={inst.id || index} className="p-3 bg-yellow-50 rounded-lg border border-yellow-200">
            <div className="flex items-center justify-between mb-2 flex-wrap gap-1">
              <span className="text-sm font-semibold text-gray-700">Veicolo {index + 1}</span>
              <div className="flex items-center gap-1 flex-wrap">
                {sfComplete ? (
                  <span
                    className="inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full bg-green-100 text-green-800 border border-green-300"
                    title={inst.salesforce_synced_at ? `Sincronizzato da SF il ${new Date(inst.salesforce_synced_at).toLocaleString('it-IT')}` : 'Marcato Complete da Salesforce'}
                    data-testid={`sf-badge-complete-${inst.id || index}`}
                  >
                    ✓ SF Complete
                  </span>
                ) : (
                  <span
                    className="inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full bg-amber-50 text-amber-800 border border-amber-300"
                    title="Job non ancora marcato Complete su Salesforce"
                    data-testid={`sf-badge-pending-${inst.id || index}`}
                  >
                    ⏳ In attesa SF
                  </span>
                )}
                {workStatus === 'completed' && (
                  <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800 border border-emerald-300" title="Lavoro completato dal tecnico">
                    Lavoro OK
                  </span>
                )}
                {workStatus === 'not_completed' && (
                  <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-red-100 text-red-800 border border-red-300" title="Lavoro non completato dal tecnico">
                    Non completato
                  </span>
                )}
                {workStatus === 'in_progress' && (
                  <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 border border-blue-300" title="Tecnico attualmente al lavoro">
                    In corso
                  </span>
                )}
                {inst.estimated_duration && (
                  <span className="text-xs text-blue-600">{inst.estimated_duration} min</span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p className="text-xs text-gray-500 uppercase">Job Number</p>
                <p className="font-bold text-gray-800">{inst.job_number}</p>
              </div>
              {inst.device_type && (
                <div>
                  <p className="text-xs text-gray-500 uppercase">Dispositivo</p>
                  <p className="font-medium text-gray-800">{inst.device_type.toUpperCase().replace(/_/g, ' ')}</p>
                </div>
              )}
              {inst.service_type && (
                <div>
                  <p className="text-xs text-gray-500 uppercase">Tipologia SVR</p>
                  <p className="font-medium text-gray-800" data-testid={`installation-svr-type-${index}`}>
                    {inst.service_type.toUpperCase()}
                  </p>
                </div>
              )}
              <div>
                <p className="text-xs text-gray-500 uppercase">Veicolo</p>
                <p className="font-medium text-gray-800">{inst.vehicle_brand} {inst.vehicle_model}</p>
              </div>
              {inst.license_plate && (
                <div>
                  <p className="text-xs text-gray-500 uppercase">Targa</p>
                  <p className="font-medium text-gray-800">{inst.license_plate}</p>
                </div>
              )}
              {inst.chassis_number && (
                <div className="col-span-2">
                  <p className="text-xs text-gray-500 uppercase">Telaio</p>
                  <p className="font-medium text-gray-800 text-xs">{inst.chassis_number}</p>
                </div>
              )}
            </div>
            {/* Extra Jobs */}
            {inst.extra_jobs && inst.extra_jobs.length > 0 && (
              <div className="mt-2 pt-2 border-t border-yellow-200">
                <p className="text-xs font-semibold text-purple-700 mb-1">Job Aggiuntivi:</p>
                {inst.extra_jobs.map((ej, ejIdx) => {
                  const ejComplete = (ej.salesforce_status || '').toLowerCase() === 'complete';
                  return (
                  <div key={ejIdx} className="flex items-center gap-3 text-xs py-0.5">
                    <span className="font-bold text-gray-800">{ej.job_number}</span>
                    {ej.device_type && <span className="text-purple-600">{ej.device_type.toUpperCase().replace(/_/g, ' ')}</span>}
                    {ej.job_number && (
                      ejComplete ? (
                        <span className="text-[9px] font-medium px-1.5 py-0.5 rounded-full bg-green-100 text-green-800 border border-green-300" data-testid={`sf-badge-extra-complete-${index}-${ejIdx}`}>✓ SF Complete</span>
                      ) : (
                        <span className="text-[9px] font-medium px-1.5 py-0.5 rounded-full bg-amber-50 text-amber-800 border border-amber-300" data-testid={`sf-badge-extra-pending-${index}-${ejIdx}`}>⏳ In attesa SF</span>
                      )
                    )}
                  </div>
                  );
                })}
              </div>
            )}
          </div>
          );
        })}
      </div>
    );
  }

  // Legacy single installation
  if (appointment.job_number || appointment.device_type) {
    return (
      <div className="grid grid-cols-2 gap-4 p-3 bg-yellow-50 rounded-lg border border-yellow-200">
        {appointment.job_number && (
          <div>
            <p className="text-xs text-gray-500 uppercase font-medium">{t('appointment.jobNumber')}</p>
            <p className="font-bold text-gray-800">{appointment.job_number}</p>
          </div>
        )}
        {appointment.device_type && (
          <div>
            <p className="text-xs text-gray-500 uppercase font-medium">{t('appointment.deviceType')}</p>
            <p className="font-medium text-gray-800">
              {t(`appointment.deviceTypes.${appointment.device_type}`, appointment.device_type.toUpperCase())}
            </p>
            {appointment.estimated_duration && (
              <p className="text-xs text-blue-600 flex items-center gap-1">
                {Math.floor(appointment.estimated_duration / 60)}:{String(appointment.estimated_duration % 60).padStart(2, '0')} ore
              </p>
            )}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default InstallationsPanel;
